import { render, staticRenderFns } from "./project_item.vue?vue&type=template&id=22cc19a0&"
import script from "./project_item.vue?vue&type=script&lang=js&"
export * from "./project_item.vue?vue&type=script&lang=js&"
import style0 from "./project_item.vue?vue&type=style&index=0&id=22cc19a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports